<template>
  <div class="main">
    <div class="departures-search">
      <input
        type="text"
        placeholder="BUSCA TU SALIDA POR DESTINO O FECHA"
        v-model="search"
      >
    </div>
    <table class="tbl">
      <tr class="text-nowrap">
        <th><span>SALIDA</span></th>
        <th><span>FECHA</span></th>
        <th><span /></th>
        <th><span>EMBARQUE</span></th>
        <th><span>DESDE</span></th>
        <th><span /></th>
      </tr>
      <tr
        v-for="(item, i) in previews"
        :key="i"
      >
        <td>
          <span>{{ item.alias || item.name }}</span>
        </td>
        <td>
          <span>{{ item.date }}</span>
        </td>
        <td>
          <span
            class="pill pill-black pill-xs"
            v-if="item.fresh"
          >¡NUEVO!</span>
          <span
            class="pill pill-red pill-xs"
            v-if="item.promo"
          >¡PROMO!</span>
        </td>
        <td>
          <span class="txt-orange">{{ item.origin }}</span>
        </td>
        <td>
          <span>{{ item.currency }}{{ item.initial_price }}</span>
        </td>
        <td class="txt-right">
          <a
            class="tbl-link"
            @click.prevent="open(item.id)"
            href="#"
          >VER DETALLE</a>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { search, yyyymmdd_ddmmyyy } from '@/utils'
export default {
  data () {
    return {
      search: null
    }
  },

  computed: {
    previews () {
      return search(this.$store.state.previews, this.search).map(departure => ({
        date: yyyymmdd_ddmmyyy(departure.date_departure),
        ...departure
      }))
    }
  },

  methods: {
    open (id) {
      this.$router.push({ name: 'departure', params: { id } })
    }
  }
}
</script>
